// extracted by mini-css-extract-plugin
module.exports = {"NavItems":"NavItems_NavItems__1hEzt"};